import React from 'react';
import { Award, Shield, Target, Globe } from 'lucide-react';
export function About() {
  const features = [{
    icon: <Award className="w-6 h-6 text-gold" data-id="element-16" />,
    title: '15+ Years Expertise',
    description: 'Decades of specialized experience in executive branding and board-level positioning.'
  }, {
    icon: <Target className="w-6 h-6 text-gold" data-id="element-17" />,
    title: 'Board Specialization',
    description: 'Deep understanding of governance, leadership, and corporate strategy requirements.'
  }, {
    icon: <Shield className="w-6 h-6 text-gold" data-id="element-18" />,
    title: 'Trusted by Leaders',
    description: 'Partnering with executives across Fortune 500 companies and global organizations.'
  }, {
    icon: <Globe className="w-6 h-6 text-gold" data-id="element-19" />,
    title: 'Cross-Industry Reach',
    description: 'Expertise spanning aerospace, healthcare, tech, finance, energy, and nonprofits.'
  }];
  return <section id="about" className="py-24 bg-white" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-22">
          <div data-id="element-23">
            <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-24">
              About Our Firm
            </span>
            <h2 className="text-3xl md:text-5xl font-serif-display font-bold text-navy-900 mb-6 leading-tight" data-id="element-25">
              Elevating Leadership Profiles for the Modern Boardroom
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed mb-6" data-id="element-26">
              We are a premier executive branding consultancy specializing in
              the development of high-impact board and executive resumes. For
              over 15 years, we have partnered with top-tier leaders to
              articulate their strategic value, governance expertise, and
              leadership legacy.
            </p>
            <p className="text-gray-600 text-lg leading-relaxed mb-10" data-id="element-27">
              Our deep understanding of corporate strategy and board dynamics
              allows us to craft narratives that resonate with search firms,
              nominating committees, and corporate boards across the globe.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-28">
              {features.map((feature, index) => <div key={index} className="flex flex-col" data-id="element-29">
                  <div className="mb-3 bg-navy-50 w-12 h-12 rounded-sm flex items-center justify-center" data-id="element-30">
                    {feature.icon}
                  </div>
                  <h3 className="text-navy-900 font-bold text-lg mb-2" data-id="element-31">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed" data-id="element-32">
                    {feature.description}
                  </p>
                </div>)}
            </div>
          </div>

          <div className="relative" data-id="element-33">
            <div className="absolute inset-0 bg-gold transform translate-x-4 translate-y-4 rounded-sm" data-id="element-34"></div>
            <img src="https://images.unsplash.com/photo-1556761175-5973dc0f32d7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Executive Meeting" className="relative z-10 w-full h-auto object-cover rounded-sm shadow-xl" data-id="element-35" />
            <div className="absolute -bottom-8 -left-8 bg-navy-900 p-8 rounded-sm shadow-2xl z-20 max-w-xs hidden md:block" data-id="element-36">
              <p className="text-white font-serif-display text-2xl italic mb-2" data-id="element-37">
                "The gold standard in executive branding."
              </p>
              <p className="text-gold text-sm font-semibold uppercase tracking-wider" data-id="element-38">
                — Global Search Firm Partner
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}